// All with dark strap
// import React from 'react';
// import { Link, useNavigate } from 'react-router-dom';

// const Navbar = ({ user, setUser, role }) => {
//   const navigate = useNavigate();

//   const handleLogout = () => {
//     localStorage.clear();
//     if (setUser) setUser(null);
//     navigate('/');
//   };

//   return (
//     <nav style={{ backgroundColor: "#0f172a" }} className="w-full">
      
//       {/* STRAP CONTAINER */}
//       <div className="w-full border-b border-gray-700 shadow-lg">
//         <div className="max-w-7xl mx-auto px-8 h-20 flex items-center justify-between">
          
//           {/* LEFT SIDE */}
//           <div className="flex items-center gap-3">
//             <div className="w-9 h-9 bg-white rounded-full"></div>
//             <span className="text-white text-xl font-bold tracking-wide">
//               Family Trust
//             </span>
//           </div>

//           {/* RIGHT SIDE */}
//           <div className="flex items-center gap-10 text-white text-base font-medium">

//             <Link to="/" className="hover:text-blue-400 transition">
//               Home
//             </Link>

//             <Link to="/about" className="hover:text-blue-400 transition">
//               About
//             </Link>

//             <button
//               onClick={() =>
//                 document.getElementById('tree-view')?.scrollIntoView({ behavior: 'smooth' })
//               }
//               className="bg-transparent border-none outline-none hover:text-blue-400 transition cursor-pointer"
//             >
//               Explore Family Tree
//             </button>

//             {user ? (
//               <>
//                 <span className="text-xs bg-slate-800 text-blue-300 px-3 py-1 rounded-md uppercase font-semibold">
//                   {user.role || role}
//                 </span>

//                 <button
//                   onClick={handleLogout}
//                   className="bg-red-600 hover:bg-red-500 text-white px-5 py-2 rounded-md text-sm font-semibold transition"
//                 >
//                   Logout
//                 </button>
//               </>
//             ) : (
//               <Link
//                 to="/login"
//                 className="bg-blue-600 hover:bg-blue-500 text-white px-5 py-2 rounded-md text-sm font-semibold transition"
//               >
//                 Sign In
//               </Link>
//             )}
//           </div>

//         </div>
//       </div>
//     </nav>
//   );
// };

// export default Navbar;





















// //Exact Working 
// import React from 'react';
// import { Link, useNavigate, useLocation } from 'react-router-dom';

// const Navbar = ({ user, setUser, role }) => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const handleLogout = () => {
//     localStorage.clear();
//     if (setUser) setUser(null);
//     navigate('/');
//   };

//   const isHomePage = location.pathname === '/';

//   return (
//     <nav className="bg-white w-full border-b border-gray-200 shadow-sm sticky top-0 z-50 font-sans">
//       {/* max-w-7xl centers the content, px-6 gives padding, flex justify-between forces Left vs Right */}
//       <div className="max-w-7xl mx-auto px-6 h-20 flex justify-between items-center">
        
//         {/* FAR LEFT: Brand / Logo */}
//         <div className="flex-shrink-0 flex items-center">
//           <Link to="/" className="text-3xl font-extrabold text-blue-700 tracking-tight flex items-center gap-2">
//             <span className="text-2xl">🌳</span> FamilyTrust
//           </Link>
//         </div>

//         {/* FAR RIGHT: Navigation + Auth Buttons */}
//         <div className="flex items-center gap-8">
          
//           {/* Nav Links */}
//           <div className="hidden md:flex items-center gap-6">
//             <Link to="/" className="text-gray-600 hover:text-blue-600 font-semibold transition-colors">
//               Home
//             </Link>
//             <Link to="/about" className="text-gray-600 hover:text-blue-600 font-semibold transition-colors">
//               About
//             </Link>
//             {isHomePage && (
//               <button
//                 onClick={() => document.getElementById('tree-view')?.scrollIntoView({ behavior: 'smooth' })}
//                 className="text-gray-600 hover:text-blue-600 font-semibold transition-colors cursor-pointer"
//               >
//                 Explore Tree
//               </button>
//             )}
//           </div>

//           {/* Vertical Divider */}
//           <div className="hidden md:block h-8 w-px bg-gray-300"></div>

//           {/* Auth Actions */}
//           <div className="flex items-center gap-4">
//             {user ? (
//               <>
//                 <span className="hidden sm:inline-block text-xs bg-blue-50 text-blue-700 px-3 py-1.5 rounded-md border border-blue-200 font-bold uppercase tracking-wide">
//                   {user.role || role}
//                 </span>
//                 <button
//                   onClick={handleLogout}
//                   className="text-red-600 hover:text-red-700 font-semibold transition-colors px-2"
//                 >
//                   Logout
//                 </button>
//               </>
//             ) : (
//               <Link
//                 to="/login"
//                 className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-lg text-sm font-bold shadow-md transition-all"
//               >
//                 Sign In
//               </Link>
//             )}
//           </div>
          
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default Navbar;


















// import React from 'react';
// import { Link, useNavigate, useLocation } from 'react-router-dom';

// const Navbar = ({ user, setUser, role }) => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const handleLogout = () => {
//     localStorage.clear();
//     if (setUser) setUser(null);
//     navigate('/');
//   };

//   const isHomePage = location.pathname === '/';
  
//   // Dynamically determine where the dashboard link should go
//   const userRole = user?.role || role;
//   const dashboardPath = userRole === 'ADMIN' ? '/admin' : '/customer';

//   return (
//     <nav className="bg-white w-full border-b border-gray-200 shadow-sm sticky top-0 z-50 font-sans">
//       <div className="max-w-7xl mx-auto px-6 h-20 flex justify-between items-center">
        
//         {/* FAR LEFT: Brand / Logo */}
//         <div className="flex-shrink-0 flex items-center">
//           <Link to="/" className="text-3xl font-extrabold text-blue-700 tracking-tight flex items-center gap-2">
//             <span className="text-2xl">🌳</span> FamilyTree
//           </Link>
//         </div>

//         {/* FAR RIGHT: Navigation + Auth Buttons */}
//         <div className="flex items-center gap-8">
          
//           {/* Nav Links */}
//           <div className="hidden md:flex items-center gap-6">
//             <Link to="/" className="text-gray-600 hover:text-blue-600 font-semibold transition-colors">
//               Home
//             </Link>
//             <Link to="/about" className="text-gray-600 hover:text-blue-600 font-semibold transition-colors">
//               About
//             </Link>

//             {/* NEW: Dynamic Dashboard Link (Only shows if logged in) */}
//             {user && (
//               <Link to={dashboardPath} className="text-blue-600 hover:text-blue-800 font-bold transition-colors">
//                 Dashboard
//               </Link>
//             )}

//             {isHomePage && (
//               <button
//                 onClick={() => document.getElementById('tree-view')?.scrollIntoView({ behavior: 'smooth' })}
//                 className="text-gray-600 hover:text-blue-600 font-semibold transition-colors cursor-pointer"
//               >
//                 Explore Tree
//               </button>
//             )}
//           </div>

//           {/* Vertical Divider */}
//           <div className="hidden md:block h-8 w-px bg-gray-300"></div>

//           {/* Auth Actions */}
//           <div className="flex items-center gap-4">
//             {user ? (
//               <>
//                 {/* NEW: Made the badge a clickable link back to their panel */}
//                 <Link
//                   to={dashboardPath}
//                   className="hidden sm:inline-block text-xs bg-blue-50 hover:bg-blue-100 text-blue-700 px-3 py-1.5 rounded-md border border-blue-200 font-bold uppercase tracking-wide transition-colors"
//                   title="Return to Panel"
//                 >
//                   {userRole} Panel
//                 </Link>
                
//                 <button
//                   onClick={handleLogout}
//                   className="text-red-600 hover:text-red-700 font-semibold transition-colors px-2"
//                 >
//                   Logout
//                 </button>
//               </>
//             ) : (
//               <Link
//                 to="/login"
//                 className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-lg text-sm font-bold shadow-md transition-all"
//               >
//                 Sign In
//               </Link>
//             )}
//           </div>
          
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default Navbar;

import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const Navbar = ({ user, setUser, role }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.clear();
    if (setUser) setUser(null);
    navigate('/');
  };

  const isHomePage = location.pathname === '/';
  
  const userRole = user?.role || role;
  const dashboardPath = userRole === 'ADMIN' ? '/admin' : '/customer';

  return (
    <nav className="bg-white w-full border-b border-gray-200 shadow-sm sticky top-0 z-50 font-sans">
      <div className="max-w-7xl mx-auto px-6 h-20 flex justify-between items-center">
        
        <div className="flex-shrink-0 flex items-center">
          <Link to="/" className="text-3xl font-extrabold text-blue-700 tracking-tight flex items-center gap-2">
            <span className="text-2xl">🌳</span> KhadilkarFamilyTree
          </Link>
        </div>

        <div className="flex items-center gap-8">
          <div className="hidden md:flex items-center gap-6">
            <Link to="/" className="text-gray-600 hover:text-blue-600 font-semibold transition-colors">
              Home
            </Link>
            <Link to="/about" className="text-gray-600 hover:text-blue-600 font-semibold transition-colors">
              About
            </Link>
            
            {/* NEW FORUM LINK */}
            <Link to="/forum" className="text-gray-600 hover:text-blue-600 font-semibold transition-colors">
              Forum
            </Link>

            {user && (
              <Link to={dashboardPath} className="text-blue-600 hover:text-blue-800 font-bold transition-colors">
                Dashboard
              </Link>
            )}

            {isHomePage && (
              <button
                onClick={() => document.getElementById('tree-view')?.scrollIntoView({ behavior: 'smooth' })}
                className="text-gray-600 hover:text-blue-600 font-semibold transition-colors cursor-pointer"
              >
                Explore Tree
              </button>
            )}
          </div>

          <div className="hidden md:block h-8 w-px bg-gray-300"></div>

          <div className="flex items-center gap-4">
            {user ? (
              <>
                <Link
                  to={dashboardPath}
                  className="hidden sm:inline-block text-xs bg-blue-50 hover:bg-blue-100 text-blue-700 px-3 py-1.5 rounded-md border border-blue-200 font-bold uppercase tracking-wide transition-colors"
                  title="Return to Panel"
                >
                  {userRole} Panel
                </Link>
                
                <button
                  onClick={handleLogout}
                  className="text-red-600 hover:text-red-700 font-semibold transition-colors px-2"
                >
                  Logout
                </button>
              </>
            ) : (
              <Link
                to="/login"
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-lg text-sm font-bold shadow-md transition-all"
              >
                Sign In
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;